import React from 'react';
import { func } from 'prop-types';

import Form from '../Form';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';
import PasswordInput from 'elements/Inputs/PasswordInput';
import Button from 'elements/Buttons/Button';
import { SectionHeader, BottomActionCall } from '../Layout';

import styles from './CreateAccountForm.css';

const  CreateAccountForm = ({ onSubmit }) => (
  <Form className={styles.createAccountForm} onSubmit={onSubmit}>
    <SectionHeader title='Create New Account.' />
    <FormField>
      <InputField
        label="Email"
        validations={['required', 'email']}
      />
    </FormField>
    <FormField>
      <PasswordInput
        label="Password"
        customClasses="withIcon"
        validations={['required', 'password']}
      />
    </FormField>
    <Button>Create Account</Button>
    <BottomActionCall
      icon="exit"
      text="Already have an account?"
      linkText="login"
    />
  </Form>
);

CreateAccountForm.propTypes = {
  onSubmit: func,
};

CreateAccountForm.displayName = 'CreateAccountForm';

export default CreateAccountForm;



// WEBPACK FOOTER //
// ./src/uis/components/Form/CreateAccountForm/CreateAccountForm.js